import React from 'react';
import { Zap, Monitor, Search, Star, Calendar, DollarSign } from 'lucide-react';
import { motion } from 'framer-motion';
const items = [{
  icon: Zap,
  label: 'Smart Auto-Responders',
  subtext: 'Instant lead follow-up, 24/7',
  delay: 0
}, {
  icon: Monitor,
  label: 'Conversion-Optimized Website',
  subtext: 'Mobile-friendly, fast loading',
  delay: 0.1
}, {
  icon: Search,
  label: 'Local SEO Setup',
  subtext: 'Found by customers in your area',
  delay: 0.2
}, {
  icon: DollarSign,
  label: 'Yelp Ads Campaign',
  subtext: 'Managed ad spend for lead generation',
  delay: 0.3
}, {
  icon: Star,
  label: 'Yelp Profile Management',
  subtext: 'Optimized for maximum visibility',
  delay: 0.4
}, {
  icon: Calendar,
  label: 'Automated Booking System',
  subtext: 'Let customers schedule instantly',
  delay: 0.5
}];
export function SetupGrid() {
  return <section className="py-24 bg-white" data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="text-center mb-16" data-id="element-191">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-192">
            What We Set Up
          </h2>
          <p className="text-xl text-slate-600" data-id="element-193">
            A complete automated ecosystem for lead capture and conversion
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-194">
          {items.map((item, index) => <motion.div key={item.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: item.delay,
          duration: 0.5
        }} className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-md border border-slate-100 hover:shadow-lg transition-shadow h-full" data-id="element-195">
              <div className="p-4 bg-slate-50 rounded-full mb-4 text-emerald-600" data-id="element-196">
                <item.icon className="w-8 h-8" data-id="element-197" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-198">{item.label}</h3>
              <p className="text-sm text-slate-500" data-id="element-199">{item.subtext}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}